import React from "react";
import { Link } from "react-router-dom";
import Navbar from "src/components/Navbar";
import Footer from "src/components/Footer";
import { gallery } from "src/assets/images";
import { CarouselDemo } from "src/components/CarouselDemo";
import { getEvents } from "src/api";
import { useQuery } from "@tanstack/react-query";
import { format } from "date-fns";




const Gallery = () => {
    const { data: events } = useQuery({
        queryKey: ["getEvents"],
        queryFn: () => getEvents(),
    });

    return (
        <div className="relative">
            <Navbar />
            <CarouselDemo />
            <div className="container mx-auto py-[70px]">
                <section>
                    <h1 className="fatix-gallery-gallery">Gallery</h1>
                    <h6 className="fatix-gallery-subgallery">Browse through events taking place at Fatix Wax</h6>
                </section>
                <section>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {events?.data && events.data.length > 0 ? (
                            events.data.map((event) => {
                                const imageUrl = event.images?.length > 0 ? event.images[0].url : gallery;

                                return (
                                    <div key={event.id} className="bg-white overflow-hidden">
                                        <img
                                            src={imageUrl}
                                            alt={event.name}
                                            className="w-full h-[400px] object-cover"
                                        />
                                        <div className="py-4">
                                            <h2 className="font-bold event-title">{event.name}</h2>
                                            <p className="text-gray-600 event-date">
                                                {event?.date ? format(new Date(event.date), "MMM d, yyyy") : "Date not available"}
                                            </p>
                                            <Link
                                                to={`/gallery/${event.id}`}
                                                className="mt-3 inline-block fatix-see-more hover:underline"
                                            >
                                                See More
                                            </Link>
                                        </div>
                                    </div>
                                );
                            })
                        ) : (
                            <h1 className="col-span-full text-center text-gray-500">No event available</h1>
                        )}
                    </div>

                </section>

            </div>
            <Footer />
        </div>
    );
};

export default Gallery;
